import { useMemo } from "react";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { useEntities } from "@hooks/useEntities";
import { useOverlays } from "contexts/OverlayContext";
import { useAccountingMigration } from "@api/accountingIntegration.api";
import { Drawer } from "@design-system/Drawer";
import { QuickbooksMapAccounts } from "./QuickbooksMapAccounts";
import styles from "./QuickbooksMapAccounts.module.scss";

export const QuickbooksMapAccountsContainer = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();
    const overlayInfo = getOverlayInfo("quickbooksMapAccounts");

    const entities = useEntities({
        onlyBusiness: true,
        excludeMockEntities: true,
    });

    const entity = useMemo(
        () => entities.find((e) => e.id === overlayInfo?.data?.entityId),
        [entities, overlayInfo?.data?.entityId],
    );

    const workspaceId = overlayInfo?.data?.connectionWorkspaceId;

    const { data: accountingMigration } = useAccountingMigration(
        workspaceId ?? null,
        entity?.id,
    );

    if (!overlayInfo?.data || !entity || !workspaceId || !accountingMigration) {
        return null;
    }

    return (
        <Drawer
            size="fullScreen"
            contentClassName={styles.drawerContent}
            headerAddonLeft={
                <span className={styles.modalHeaderContent}>
                    Review account types for
                    <EntityAvatar entity={entity} size="xs" aria-hidden />
                    {entity.name}
                </span>
            }
            onClose={closeOverlay}
            open={!overlayIsClosing}
            noPadding
        >
            <QuickbooksMapAccounts
                workspaceId={workspaceId}
                entity={entity}
                nextTaskId={overlayInfo.data.nextTaskId}
            />
        </Drawer>
    );
};
